import { Collapse, Grid } from '@mui/material';
import { CONTRACT_TYPES } from '@vy/types';
import { isSingleItem, keys } from '@vy/utils';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useCreatePlanContext } from '../../../../../contexts/create-plan-context';
import type { PlanCreationStep } from '../../../../../contexts/create-plan-context/create-plan-context-types/plan-creation-step';
import { useGetContractPrerequisites } from '../../create-plan-page-hooks/useGetContractPrerequisites';
import type { PlanInputForm } from '../CreatePlanForm/create-plan-form-types/plan-input-form';
import { CreatePlanLivePreview } from '../CreatePlanLivePreview/CreatePlanLivePreview';
import { CreatePlanPageStepper } from '../CreatePlanPageStepper/CreatePlanPageStepper';

type NewCreatePlanPageContentProps = {
  stepsContent: Record<PlanCreationStep, React.ReactElement>;
};

export const CreatePlanPageContent: React.FC<NewCreatePlanPageContentProps> = ({ stepsContent }) => {
  const {
    planCreationStepper: { currentStep },
    planPreview: { open, hide },
  } = useCreatePlanContext();

  const contractPrerequisites = useGetContractPrerequisites();
  const formContext = useFormContext<PlanInputForm>();
  const formValues = formContext ? formContext.getValues() : null;

  const isParentAgreement =
    contractPrerequisites?.contractType === CONTRACT_TYPES.ParentAgreement ||
    formValues?.contractType === CONTRACT_TYPES.ParentAgreement;

  const isSingleStep = isSingleItem(keys(stepsContent));

  const shouldShowPreview = open && !isParentAgreement;

  return (
    <Grid
      container
      direction="row"
      wrap="nowrap"
      sx={{
        bgcolor: "#FAFAFA",
        height: 1,
        overflow: "hidden"
      }}>
      <Grid size="grow" sx={{
        position: "relative",
        minWidth: 0
      }}>
        <div className="bg-white w-full">{!isSingleStep && <CreatePlanPageStepper />}</div>

        <div className="flex w-full h-[calc(100%-24px)] absolute">{stepsContent[currentStep]}</div>
      </Grid>
      <Grid>
        <Collapse
          in={shouldShowPreview}
          orientation="horizontal"
          sx={{
            height: '100%',
          }}
        >
          <CreatePlanLivePreview title="Plan Preview" onHide={hide} />
        </Collapse>
      </Grid>
    </Grid>
  );
};
